<template>
  <div class="toolbar">
      <v-app-bar flat height="80" color="darkblue" app class="top-navbar pa-0">
        <v-container class="py-0 px-md-6 fill-height">
          <v-row no-gutters align="center">
            <router-link :to="{ name: 'Home' }">
              <img src="/assets/images/bw-legal-logo-inverted.svg" alt="BW Legal Logo" width="97px" height="26px" class="logo"/>
            </router-link>
            <v-toolbar-title class="ml-1 top-navbar__brand">
              {{appTitle}}
            </v-toolbar-title>
            <v-spacer></v-spacer>
            <nav class="hidden-md-and-down">
              <router-link :to="{ name: 'Home' }">
                <v-btn text dark class="ml-4">
                  Home
                </v-btn>
              </router-link>
              <v-menu offset-y>
                <template v-slot:activator="{ on, attrs }">
                  <v-btn
                    text
                    dark
                    v-bind="attrs"
                    v-on="on"
                  >
                    Services
                    <v-icon x-small class="nav-icon">
                      fa-chevron-down
                    </v-icon>
                  </v-btn>
                </template>
                <v-list>
                  <v-list-item v-for="(item, index) in serviceMenuItems" :key="index" :to="{ name: item.route }">
                    <v-list-item-title>
                        {{ item.title }}
                    </v-list-item-title>
                  </v-list-item>
                </v-list>
              </v-menu>
              <router-link v-for="(item, index) in menuItems" :key="index" :to="{ name: item.route }">
                <v-btn text dark>
                  {{ item.title }}
                </v-btn>
              </router-link>
              <router-link :to="{ name: 'ContactUs' }">
                <v-btn color="primary" outlined large class="ml-4">
                  Contact Us
                </v-btn>
              </router-link>
            </nav>
            <v-app-bar-nav-icon dark @click.stop="sidebar = !sidebar" class="hidden-lg-and-up" aria-label="Menu"></v-app-bar-nav-icon>
          </v-row>
        </v-container>
      </v-app-bar>
      <v-navigation-drawer
        v-model="sidebar"
        temporary
        color="darkblue"
        dark
        app
        class="hidden-lg-and-up">
        <v-list>
          <v-list-item-group color="primary">
            <div v-for="(item, index) in sidebarItems" :key="index">
              <v-list-item
                v-if="item.subLinks.length === 0"
                :to="{ name: item.route }"
                exact
                link>
                <v-list-item-icon>
                  <v-icon>{{ getNavIcon(item.route) }}</v-icon>
                </v-list-item-icon>
                <v-list-item-content>
                  <v-list-item-title>{{ item.title }}</v-list-item-title>
                </v-list-item-content>
              </v-list-item>
              <v-list-group v-else no-action :value="subLinksContainActiveRoute(item.subLinks)">
                <template v-slot:activator>
                  <v-list-item-icon>
                    <v-icon>{{ getNavIcon(item.route) }}</v-icon>
                  </v-list-item-icon>
                  <v-list-item-title>{{ item.title }}</v-list-item-title>
                </template>
                <v-list-item
                  v-for="(subLink, i) in item.subLinks"
                  :key="i"
                  :to="{ name: subLink.route }"
                  link>
                  <v-list-item-title v-text="subLink.title"></v-list-item-title>
                </v-list-item>
              </v-list-group>
            </div>
          </v-list-item-group>
        </v-list>
      </v-navigation-drawer>
  </div>
</template>

<script>
import { navMixin } from '@/mixins/navigationMixin.js';

export default {
  name: 'Navigation',
  data () {
    return {
      appTitle: 'Business',
      sidebar: null,
    };
  },
  mixins: [navMixin],
  computed: {
    menuItems () {
      let items = [
        this.routes.AboutUs,
        this.routes.Careers,
        this.routes.CustomerSite,
      ];
      return this.routesToArray(items)
    },
    sidebarItems () {
      let items = [
        this.routes.Home,
        this.routes.Services,
        this.routes.AboutUs,
        this.routes.Careers,
        this.routes.CustomerSite,
        this.routes.ContactUs
      ];
      return this.routesToArray(items)
    },
    serviceMenuItems () {
      let items = [
        this.routes.Services
      ];
      return items[0].subLinks;
    }
  },
  methods: {
    subLinksContainActiveRoute (subLinks) {
      return subLinks.some(x => x.route === this.activeRoute);
    }
  }
};
</script>

<style scoped>
.top-navbar__brand {
  font-weight: 500;
  color: #fff;
  font-size: 26px;
  margin-bottom: 2px;
  text-decoration: none;
}

.top-navbar .v-icon {
  color: var(--v-secondary-lighten4);
}

.top-navbar a {
  text-decoration: none;
  color: #fff;
}

.v-application--is-ltr .v-list-item__action:first-child,
.v-application--is-ltr .v-list-item__icon:first-child {
  margin-right: 28px;
}

.v-list-item__action,
.v-list-item__avatar,
.v-list-item__icon {
  display: inline-flex;
  min-width: 28px;
}

.v-item-group.v-bottom-navigation .v-btn {
  min-width: unset;
}

.v-icon.v-icon {
  width: 24px;
  font-size: 20px;
}

.nav-icon {
  width: 14px !important;
  margin-right: -4px !important;
  margin-left: 8px !important;
}

.logo {
  cursor: pointer;
  vertical-align: middle;
}

</style>
